import React from 'react';
import Input from '../../../components/ui/Input';

const BasicInfoSection = ({ 
  formData, 
  errors, 
  onChange 
}) => {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg md:text-xl font-semibold text-foreground mb-4">
          Основная информация
        </h3>
        <p className="text-sm text-text-secondary mb-6">
          Базовые настройки вашего сайта для аренды помещений
        </p>
      </div>
      <Input
        label="Название сайта"
        type="text"
        name="siteName"
        placeholder="Например: Коворкинг Центр"
        value={formData?.siteName}
        onChange={onChange}
        error={errors?.siteName}
        required
        description="Отображается в заголовке браузера и поисковых системах"
        className="mb-4"
      />
      <Input
        label="Описание сайта"
        type="text"
        name="siteDescription"
        placeholder="Краткое описание вашего бизнеса"
        value={formData?.siteDescription}
        onChange={onChange}
        error={errors?.siteDescription}
        description="Краткое описание для поисковых систем (до 160 символов)"
        maxLength={160}
        className="mb-4"
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <Input
          label="Контактный телефон"
          type="tel"
          name="contactPhone"
          placeholder="+7 (999) 123-45-67"
          value={formData?.contactPhone}
          onChange={onChange}
          error={errors?.contactPhone}
          required
        />

        <Input
          label="Email для связи"
          type="email"
          name="contactEmail"
          placeholder="info@example.ru"
          value={formData?.contactEmail}
          onChange={onChange}
          error={errors?.contactEmail}
          required
        />
      </div>
      <Input
        label="Адрес"
        type="text"
        name="address"
        placeholder="г. Москва, ул. Примерная, д. 1"
        value={formData?.address}
        onChange={onChange}
        error={errors?.address}
        className="mb-4"
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <Input
          label="Часы работы (будни)"
          type="text"
          name="workingHoursWeekdays"
          placeholder="09:00 - 18:00"
          value={formData?.workingHoursWeekdays}
          onChange={onChange}
          error={errors?.workingHoursWeekdays}
        />

        <Input
          label="Часы работы (выходные)"
          type="text"
          name="workingHoursWeekends"
          placeholder="10:00 - 16:00"
          value={formData?.workingHoursWeekends}
          onChange={onChange}
          error={errors?.workingHoursWeekends}
        />
      </div>
    </div>
  );
};

export default BasicInfoSection;